export const isError = function (err) {
  // console.log("err.response",err);
  // if(err.response==undefined){
  //   return false;
  // }
  if (err?.response?.status == 901 || err?.response?.status == 401) {
    this.$store.commit("setUser", null);
    this.$router.push({ name: "Login" });
  }
  this.$swal({
    icon: "error",
    title: "Error",
    text: err?.response?.data != undefined && err?.response?.data != "" ? err?.response?.data : err?.response?.statusText,
    confirmButtonText: "Okey"
  });
}